import {
  sendFundTransferFailure,
  sendFundTransferStart,
  sendFundTransferSuccess,
  sendNameEnquiryFailure,
  sendNameEnquiryStart,
  sendNameEnquirySuccess,
  sendStatusQueryFailure,
  sendStatusQueryStart,
  sendStatusQuerySuccess,
} from "../../redux/Actions/NipActions";
import { runFundTransferTestFailure, runFundTransferTestStart, runFundTransferTestSuccess, runNameEnquiryTestFailure, runNameEnquiryTestStart, runNameEnquiryTestSuccess, runStatusQueryTestFailure, runStatusQueryTestStart, runStatusQueryTestSuccess } from "../../redux/Actions/OutwardTestActions";

export const startFunction = (name, dispatch) => {
  switch (name) {
    case "name-enquiry":
      return dispatch(sendNameEnquiryStart());
    case "funds-transfer":
      return dispatch(sendFundTransferStart());
    case "transfer-status-query":
      return dispatch(sendStatusQueryStart());
    default:
      return false;
  }
};

export const successFunction = (name, dispatch, data) => {
  switch (name) {
    case "name-enquiry":
      return dispatch(sendNameEnquirySuccess(data.data));
    case "funds-transfer":
      return dispatch(sendFundTransferSuccess(data.data));
    case "transfer-status-query":
      return dispatch(sendStatusQuerySuccess(data.data));
    default:
      return false;
  }
};

export const failureFunction = (name, dispatch, data) => {
  switch (name) {
    case "name-enquiry":
      return dispatch(sendNameEnquiryFailure(data));
    case "funds-transfer":
      return dispatch(sendFundTransferFailure(data));
    case "transfer-status-query":
      return dispatch(sendStatusQueryFailure(data));
    default:
      return false;
  }
};

export const startTestFunction = (name, dispatch) => {
  switch (name) {
    case "name-enquiry":
      return dispatch(runNameEnquiryTestStart());
    case "funds-transfer":
      return dispatch(runFundTransferTestStart());
    case "transfer-status-query":
      return dispatch(runStatusQueryTestStart());
    default:
      return false;
  }
};

export const successTestFunction = (name, dispatch, data) => {
  switch (name) {
    case "name-enquiry":
      return dispatch(runNameEnquiryTestSuccess(data && data.data));
    case "funds-transfer":
      return dispatch(runFundTransferTestSuccess(data && data.data));
    case "transfer-status-query":
      return dispatch(runStatusQueryTestSuccess(data && data.data));
    default:
      return false;
  }
};

export const failureTestFunction = (name, dispatch, data) => {
  switch (name) {
    case "name-enquiry":
      return dispatch(runNameEnquiryTestFailure(data));
    case "funds-transfer":
      return dispatch(runFundTransferTestFailure(data));
    case "transfer-status-query":
      return dispatch(runStatusQueryTestFailure(data));
    default:
      return false;
  }
};

export default { startFunction, successFunction, failureFunction };
